export var LOAD_INTEGRATION_WITH_METHODS_REQUEST = 'src/Integration/LOAD_INTEGRATION_WITH_METHODS_REQUEST';
export var LOAD_INTEGRATION_WITH_METHODS_SUCCESS = 'src/Integration/LOAD_INTEGRATION_WITH_METHODS_SUCCESS';
export var LOAD_INTEGRATION_WITH_METHODS_FAILURE = 'src/Integration/LOAD_INTEGRATION_WITH_METHODS_FAILURE';
